import { closeModal } from 'features/modal/modalSlice';
import { useTranslation } from 'react-i18next';
import { useAppDispatch } from 'store/hooks';
import ConfirmationDialog from 'components/ConfirmationDialog';
import { unlockRoomRequested } from 'features/room/actions';
import { usePermissions } from 'features/permissions/usePermissions';
import { PermissionTypes } from 'features/permissions/types';
import { useEffect } from 'react';

const UnLockRoomConfirmation = () => {
  const { t } = useTranslation('modals');
  const dispatch = useAppDispatch();

  const { hasPermissions } = usePermissions();

  const canControlRoomEntry = hasPermissions(PermissionTypes.controlRoomEntry);

  useEffect(() => {
    if (!canControlRoomEntry) {
      dispatch(closeModal('unlockRoomConfirmation'));
    }
  }, [canControlRoomEntry, dispatch]);

  const handleOk = () => {
    dispatch(unlockRoomRequested());
    dispatch(closeModal('unlockRoomConfirmation'));
  };

  const handleCancel = () => {
    dispatch(closeModal('unlockRoomConfirmation'));
  };

  return (
    <ConfirmationDialog
      open
      title={t('unlock_room_confirmation.title')}
      description={t('unlock_room_confirmation.description')}
      cancelText={t('unlock_room_confirmation.btn_cancel_label')}
      okText={t('unlock_room_confirmation.btn_ok_label')}
      onOk={handleOk}
      onCancel={handleCancel}
    />
  );
};

export default UnLockRoomConfirmation;
